import { FetchAPI } from '../Main/fetchAPI';
import { ErrorProperties } from '../identityAPIProperties';
import { AI } from '../constants';

export interface AiParseScheduleRequest {
	clientId?: string;
	prompt: string;
	providers: string[];
	sessionTypes: string[];
}

export interface AiParsedScheduleItem {
	endDate?: string | null;
	provider?: string | null;
	sessionType?: string | null;
	startDate?: string | null;
	timeSlots?: AiParsedScheduleTimeSlotItem[] | null;
}

export interface AiParsedScheduleTimeSlotItem {
	days?: string[] | null;
	endTime?: string | null;
	startTime?: string | null;
}

export interface AiParseScheduleResponse {
	error?: ErrorProperties;
	schedules?: AiParsedScheduleItem[] | null;
}

export interface AiParseSoapNoteRequest {
	barrierToTreatmentOptions: string[];
	behaviorTreatmentTechniqueOptions: string[];
	clientId?: string;
	clientMoodOptions: string[];
	clientResponseToTreatmentOptions: string[];
	currentFieldValues?: Record<string, string>;
	futurePlanOptions: string[];
	isFollowUp?: boolean;
	levelOfMaladaptiveBehaviorOptions: string[];
	maladaptiveBehaviorTechniqueOptions: string[];
	participantOptions: string[];
	reinforcerOptions: string[];
	reinforcerHardData?: string[];
	replaceableHardDataFields?: string[];
	skillDomainAddressedOptions: string[];
	skillDomainAddressedHardData?: string[];
	workedGoalsHardData?: string | null;
	frequencyAndDurationOfMaladaptiveBehaviorsHardData?: string | null;
	prompt: string;
	reportId?: string;
	sessionId?: string;
}

export interface AiParseSoapNoteResponse {
	ambiguousFields?: string[] | null;
	barrierToTreatmentOther?: string | null;
	barriersToTreatment?: string[] | null;
	behaviorTreatmentTechniques?: string[] | null;
	clientMood?: string[] | null;
	clientMoodOther?: string | null;
	clientResponseToTreatment?: string | null;
	frequencyAndDurationOfMaladaptiveBehaviors?: string | null;
	error?: ErrorProperties;
	howBarrierAffectedSession?: string | null;
	levelOfMaladaptiveBehavior?: string | null;
	maladaptiveBehaviorTechniques?: string[] | null;
	participants?: string[] | null;
	planForFutureSession?: string[] | null;
	planForFutureSessionOther?: string | null;
	reinforcementOther?: string | null;
	reinforcers?: string[] | null;
	sessionDescription?: string | null;
	skillDomainAddressed?: string[] | null;
	workedGoals?: string | null;
}

export interface AiCoverageChecklistItem {
	id: string;
	label: string;
}

export interface AiCheckSoapNoteCoverageRequest {
	checklistItems: AiCoverageChecklistItem[];
	clientId?: string;
	transcriptSoFar: string;
}

export interface AiCheckSoapNoteCoverageResponse {
	coveredIds?: string[] | null;
	error?: ErrorProperties;
}

export const Ai = {
	checkSoapNoteCoverage: (data: AiCheckSoapNoteCoverageRequest): Promise<AiCheckSoapNoteCoverageResponse> =>
		FetchAPI.postJson({
			urlStr: `${AI}/check-soap-note-coverage`,
			data,
		}),
	parseSchedule: (data: AiParseScheduleRequest): Promise<AiParseScheduleResponse> =>
		FetchAPI.postJson({
			urlStr: `${AI}/parse-schedule`,
			data,
		}),
	parseSoapNote: (data: AiParseSoapNoteRequest): Promise<AiParseSoapNoteResponse> =>
		FetchAPI.postJson({
			urlStr: `${AI}/parse-soap-note`,
			data,
		}),
};
